import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-web-demos',
  templateUrl: './web-demos.component.html',
  styleUrls: ['./web-demos.component.css']
})
export class WebDemosComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/web-demos/web-demos.component.ts